import { Dropdown } from 'react-bootstrap';

interface OrderStatusFilterProps {
  // Canonical lowercase-hyphen API value (e.g. 'prepare-shipment'), or '' for no filter.
  status: string;
  onStatusChange: (value: string) => void;
}

// Display label -> canonical value the V2 backend matches exactly (WooCommerce lowercase-hyphen).
// Sending the raw value avoids any client-side normalization.
const STATUS_OPTIONS: ReadonlyArray<{ label: string; value: string }> = [
  { label: 'Status', value: '' },
  { label: 'Processing', value: 'processing' },
  { label: 'Prepare Shipment', value: 'prepare-shipment' },
  { label: 'Shipped', value: 'shipped' },
  { label: 'Completed', value: 'completed' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Refunded', value: 'refunded' },
  { label: 'Failed', value: 'failed' },
  { label: 'Pending', value: 'pending' },
  { label: 'On Hold', value: 'on-hold' },
];

export function OrderStatusFilter({ status, onStatusChange }: OrderStatusFilterProps) {
  const activeLabel = STATUS_OPTIONS.find((o) => o.value === status)?.label ?? 'Status';

  return (
    <div className="flex items-center gap-2">
      <Dropdown className="w-full">
        <Dropdown.Toggle
          variant="outline-dark"
          className="cursor-pointer"
          style={{
            width: '160px',
            color: status ? '#EE6767' : undefined,
          }}
        >
          {activeLabel}
        </Dropdown.Toggle>
        <Dropdown.Menu className="p-2 max-h-96 overflow-y-auto" style={{ width: '180px' }}>
          {STATUS_OPTIONS.map((option) => (
            <Dropdown.Item
              className="cursor-pointer"
              key={option.value || 'all'}
              onClick={() => onStatusChange(option.value)}
              active={option.value === status}
              style={option.value === status && option.value ? { color: '#EE6767' } : {}}
            >
              {option.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
